import * as React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';

import { PolicyRuleFormView } from './policy-rule-form.view';

interface PolicyRuleFormControllerProps extends ComponentViewProps<PolicyRuleItem> {
	mode: ControlMode;
	sections: string[];
}

@observer
export class PolicyRuleFormController extends React.Component<PolicyRuleFormControllerProps, {}>  {
	@computed
	get title() {
		if (this.props.model) {
			return `Policy rule ${this.props.model.id}`;
		}

		return '';
	}

	render() {
		const { model, mode, setBusy, sections } = this.props;
		if (this.props.model == null) {
			return null;
		}

		return (
			<PolicyRuleFormView
				sections={sections}
				model={model}
				title={this.title}
				mode={mode}
				setBusy={setBusy}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policy-rules/form/policy-rule-form.controller.tsx